import React, { useState } from 'react';
import Card from '../Components/SeniorDesignGalleryCard/SeniorDesignGalleryCard';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import useSiteContent, { imageUrl } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';
import sortPhotos from '../Content/sortPhotos';

const SeniorDesign = ({ scrollPosition }) => {
  const { data, unavailable } = useSiteContent('senior-design');
  const [sort, setSort] = useState('newest');
  return <div className="main_page_container">
    <ContentNotice unavailable={unavailable} />
    <h1 className="page_title">Senior Design</h1>
    {data.paragraphs.map((paragraph, index) => <h4 key={index} className="sponsor_reg_centered_text editable-text">{paragraph.text}</h4>)}
    <label>Sort by: <select value={sort} onChange={event => setSort(event.target.value)}>
      <option value="newest">Date (Newest-Oldest)</option>
      <option value="oldest">Date (Oldest-Newest)</option>
    </select></label>
    <div className="gallery_grid">
      {sortPhotos(data.items, sort).map((photo, index) => <Card key={index} {...photo}
        image={imageUrl(photo.image)} placeholder={imageUrl(photo.placeholder)} position={scrollPosition} />)}
    </div>
  </div>;
};
export default trackWindowScroll(SeniorDesign);
